import React from 'react'
import { Helmet } from 'react-helmet-async'

function Policy() {
  
    
  return (
    <>
     <Helmet>
        <title>Our Policies for Protecting Your Privacy and Security</title>
        <meta property="og:title" content="Our Policies for Protecting Your Privacy and Security"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/user-profile"/>
        <meta property="og:description" content="Our policy page explains how we protect your privacy and security when you use our products and services. We take the protection of your personal information seriously, and our policies are designed to ensure that your information is kept safe and secure. Our policy page covers important topics such as data collection, data storage, data sharing, cookies, and information security. By reading our policies, you can feel confident that your personal information is protected when you use our site."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>

        <link rel="canonical" href="https://desireStore.online/policy" />
        <meta name="title" content="Our Policies for Protecting Your Privacy and Security"/>
        <meta name="description" data-rh="true" content="Our policy page explains how we protect your privacy and security when you use our products and services. We take the protection of your personal information seriously, and our policies are designed to ensure that your information is kept safe and secure. Our policy page covers important topics such as data collection, data storage, data sharing, cookies, and information security. By reading our policies, you can feel confident that your personal information is protected when you use our site."/>
        <meta name="keywords" content="Policy page, privacy, security, personal information, data collection, data storage, data sharing, cookies, information security"/>
      </Helmet>
    <div className="container"> 
    <div className="privacy">
    <h1>Privacy Policy</h1>
<p>Last updated: April 11, 2023 </p>

<p>Thank you for visiting our website. We are committed to protecting your privacy and providing a safe online experience. Please read this privacy policy carefully before using our website.</p>

<h2>Information we collect</h2>
<p>We do not collect any personal information from visitors to our website. We do not use cookies, log files, or any other tracking technologies.</p>

<h2>How we use your information</h2>
<p>Since we do not collect any personal information, we do not use it for any purpose.</p>

<h2>Sharing of information</h2>
<p>We do not share any information with third parties, since we do not collect any information.</p>

<h2>External links</h2>
<p>Our website may contain links to external websites that are not operated by us. We have no control over the content and privacy practices of these websites, and we cannot be responsible for their actions. We recommend that you review the privacy policy of any external website before providing any personal information.</p>

<h2>Security</h2>
<p>We take the security of our website and the privacy of our visitors seriously. We use industry-standard measures to protect our website from unauthorized access, disclosure, alteration, or destruction.</p>

<h2>Changes to this privacy policy</h2>
<p>We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon posting on the website. If we make material changes to this policy, we will notify you here that it has been updated.</p>

<h2>Contact Us</h2>
<p>If you have any questions about this Privacy Policy, you can contact us at <a href="mailto:desirestore.help@gmal.com"> desirestore.help@gmail.com</a> &amp; <a href="mailto:help@desirestore.online">help@desirestore.online</a>, or by using the contact form on our website.</p>
<ul>
  <li>Name: desirestore.online</li>
  <li>Address:  Ahemdabad, Gujarat, India.</li>
  <li>Email: desirestore.help@gmail.com</li>
  <li>Phone: N/A</li>
</ul>

<p>Thank you for using our website.</p>

    </div></div>
    </>
  )
}

export default Policy
